import { render, staticRenderFns } from "./PageAboutPurchaseBox.vue?vue&type=template&id=0baeeea0&"
import script from "./PageAboutPurchaseBox.js?vue&type=script&lang=js&"
export * from "./PageAboutPurchaseBox.js?vue&type=script&lang=js&"
import style0 from "./PageAboutPurchaseBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports